export const trxIdHandle = (trx_id) => trx_id || '--';
